<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<SalesMatterSearchDialog
					:query="q"
					:categories="categories"
					:users="users"
					:situations="situations"
					:statuses="statuses"
					@search-matters="searchMatters($event)"
					text
				/>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<SalesMatterSearchDialog
						:query="q"
						:categories="categories"
						:users="users"
						@search-matters="searchMatters($event)"
					/>
				</v-row>
			</template>

			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="matters"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="showDialog(item.id)">
							<td>
								{{ item.status_i18n }}
							</td>
							<td>
								{{ item.situation_i18n }}
							</td>
							<td>
								{{ item.quotation_number }}
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
								{{ item.customer_company.name }}
							</td>
							<td>
								{{ item.regular_customer_company.name }}
							</td>
							<td>
								{{ item.team_member_name }}
							</td>
							<td>
								{{ item.construction_name }}
							</td>
							<td>
								{{ item.product_category.name }}
							</td>
							<td>
								{{ common.formatDate(item.deadline) }}
							</td>
							<td>
								{{ item.order_number }}
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<!-- <MatterShowDialog
			:dialog.sync="dialog"
			:id="selectedId"
			requiredFetch
			@reload-matters="fetchMatters(q, pagination.current)"
		/> -->
		<MatterForceEditDialog :dialog.sync="dialog" :matter="{}" />
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import SalesMatterSearchDialog from "./components/SalesMatterSearchDialog.vue"
import MatterShowDialog from "../matter/components/MatterShowDialog.vue"
import MatterForceEditDialog from "../matter/components/MatterForceEditDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		SalesMatterSearchDialog,
		MatterShowDialog,
		MatterForceEditDialog,
	},
	data() {
		return {
			title: "案件一覧",
			matters: [],
			situations: [],
			categories: [],
			statuses: [],
			users: [],
			authority_flag: false,
			headers: [
				{
					text: "状態",
					value: "status_i18n",
					width: "120px",
				},
				{
					text: "確度",
					value: "situation_i18n",
					width: "120",
				},
				{
					text: "見積番号",
					value: "quotation_number",
					width: "200px",
				},
				{
					text: "案件名",
					value: "name",
					width: "200px",
				},
				{
					text: "向け先",
					value: "customer_company.name",
					width: "200px",
				},
				{
					text: "得意先",
					value: "regular_customer_company.name",
					width: "200px",
				},
				{
					text: "担当者",
					value: "team_member_name",
					width: "120px",
				},
				{
					text: "工事名",
					value: "construction_name",
					width: "200px",
				},
				{
					text: "製品分類",
					value: "product_category.name",
					width: "200px",
				},
				{
					text: "納期",
					value: "deadline",
					width: "150px",
				},
				{
					text: "受注番号",
					value: "order_number",
					width: "200px",
				},
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "updated_at desc",
				supplier_id_eq: null,
				order_date_lteq: null,
				order_date_gteq: null,
				status_type_in: ["sent", "draft", "pending", "rejected"],
			},
			suppliers: [],
			selectedId: null,
			// dialog: false,
			dialog: true,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchMatters(this.q, page, true)
	},
	methods: {
		fetchMatters(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/sales/matters", {
					params,
					headers,
				})
				.then((res) => {
					this.matters = res.data.matters
					const statuses = ["見積提出済み", "未受注", "受注済み", "製造中", "出荷済み", "計上済み"]
					this.matters = res.data.matters.map((m) => {
						m.status_i18n = statuses[Math.floor(Math.random() * statuses.length)]
						m.construction_place = m.construction_place ? m.construction_place : "-"
						return m
					}) // テスト用
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.users = res.data.users
						this.categories = res.data.categories
						this.situations = res.data.situations
						this.statuses = res.data.statuses
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		formattedOrderNumber(matter) {
			if (matter.sub_number) {
				return `${matter.order_number}-${String(matter.sub_number).padStart(3, "0")}`
			} else {
				return matter.order_number
			}
		},
		showDialog(id) {
			this.selectedId = id
			this.dialog = true
		},
		getPage(page) {
			this.fetchMatters(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchMatters(q) {
			this.q = q
			this.fetchMatters(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}
</script>
